import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { v4 as uuid } from "uuid";
import { ActiveToast } from "ngx-toastr";
import { IVisionToast } from "../../interfaces/i-vision-toast";

@Injectable({
  providedIn: "root",
})
export class ToastService {
  private _notifications: IVisionToast[] = [];

  protected notificationsSubject = new Subject<IVisionToast>();

  public notifications$ = this.notificationsSubject.asObservable();

  protected removeNotificationSubject = new Subject<number>();

  public removeNotification$ = this.removeNotificationSubject.asObservable();

  protected removeAllNotificationSubject = new Subject<boolean>();

  public removeAllNotification$ = this.removeAllNotificationSubject.asObservable();

  public setNotification(toast): void {
    if (toast) {
      if (!toast.id) {
        toast.id = uuid();
      }
      this._notifications.push(toast);
      this.notificationsSubject.next(toast);
    }
  }

  public getNotificationsByType(type: string): IVisionToast[] {
    const notificationsByType: IVisionToast[] = [];
    this._notifications.forEach((notification) => {
      if (notification.type === type) {
        notificationsByType.push(notification);
      }
    });
    return notificationsByType;
  }

  public getAllNotifications(): IVisionToast[] {
    return this._notifications;
  }

  public getNotificationById(id: string): IVisionToast {
    return this._notifications.find((notification) => notification.id === id);
  }

  public removeAllNotifications() {
    this._notifications = [];
    this.removeAllNotificationSubject.next(true);
  }

  public removeNotificationsByType(type: string): void {
    this._notifications.forEach((notification) => {
      if (notification.type === type) {
        this.removeNotificationByToastId(notification);
      }
    });
  }

  public removeNotificationsById(id: String): void {
    this.removeNotificationByToastId(this._notifications.find((notification) => notification.id === id));
  }

  public checkToasts(toasts: ActiveToast<any>[]) {
    if (toasts) {
      this._notifications = this._notifications.filter((notification) => {
        const found = toasts.find((toast) => toast.toastId === notification.toastId);
        return found;
      });
    } else {
      this._notifications = [];
    }
  }

  private removeNotificationByToastId(toast: IVisionToast): void {
    if (toast) {
      this.removeNotificationSubject.next(toast.toastId);
    }
  }
}
